import React, { Suspense } from "react";

import "./Wrapper.scss";
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "App/Component/ui";
import "react-datepicker/dist/react-datepicker.css";
import { Box } from "@material-ui/core";
import WrapperContext from "./context/context";
import WrapperContainer from "./WrapperContainer";
import WrapperWebSocket from "./WrapperWebSocket";
import { useTabNotification } from "App/hooks";
import PageInit from "pages/PageInit/PageInit";
import { instanceEmrV2Akses, isSSO } from "App/constants";
import { getRoleCode, removeCookie, setCookieLogin } from "App/utils/cookies";

/**
 * 
 * 
   SIMRS LOGIN 

    "id": 1,
    "code": "RSANNT",
    "name": "Rumah Sakit An-Nisa Tangerang",
    "address": "Jl. Gatot Subroto Km.3 No.96 Cibodas Kota Tangerang - Banten",
    "type": "RUMAH SAKIT",
    "postal_code": "123414",
    "city": "Tangerang",
    "no_tlpn": "5525564",
    "fax": "55791563",
    "copyright": "Copyright©.2022.ASHA-RS.AN-NISA",
    "favicon" : ""

   EMR V2 LOGIN

    "id": 1,
    "nama": "Rumah Sakit An-Nisa Tangerang",
    "kota": "Tangerang",
    "kode_pos": "123414",
    "no_tlpn": "5525564",
    "fax": "55791563"


  
 */
function Wrapper() {
  const [setNotification, clearNotification] = useTabNotification(1000);

  React.useEffect(() => {
    if (isSSO) {
      loginByApp();
    }
  }, []);

  const loginByApp = async () => {
    try {
      const response = await instanceEmrV2Akses.post("/user/login-app", {
        role_code: getRoleCode(),
        app_code: process.env.REACT_APP_CODE,
      });

      if (response.data.status === 200) {
        const data = response.data.data;
        const rs = data.rumah_sakit;
        const validResponseSIMRS = {
          bpjs_id: data.id_asuransi_bpjs,
          token: data.token,
          body: {
            ...response.data.data,
            rumah_sakit: {
              id: rs.id,
              code: "",
              name: rs.nama,
              address: "",
              type: "RUMAH SAKIT",
              postal_code: rs.kode_pos,
              city: rs.kota,
              no_tlpn: rs.no_tlpn,
              fax: rs.fax,
              copyright: "",
              favicon: "",
            },
          },
        };
        setCookieLogin(validResponseSIMRS);
      } else {
        removeCookie();
      }
    } catch (error) {
      removeCookie();
    }
  };
  return (
    <Suspense fallback={<FullLoading isLoading={true} />}>
      <PageInit>
        <WrapperContext>
          <WrapperWebSocket setNotification={setNotification} />
          <WrapperContainer clearNotification={clearNotification} />
        </WrapperContext>
      </PageInit>
    </Suspense>
  );
}

export const FullLoading = ({ isLoading }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: "0",
        background: "rgba(0,0,0,0.6)",
        zIndex: 99999,
      }}
      className='wrapper-loading'>
      <Loading show={isLoading} />
    </Box>
  );
};

export default Wrapper;
